import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import PortalVue from 'portal-vue'
import { i18n } from './i18n'
import axiosConfig from './router/axios'
import VModal from 'vue-js-modal'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import helpers from './helpers'
import VTooltip from 'v-tooltip'
import VueLuxon from 'vue-luxon'
import VueApexCharts from 'vue-apexcharts'
import VueCal from 'vue-cal'

require('./components/components')
require('./icons')

Vue.config.productionTip = false

Vue.use(PortalVue)

axiosConfig()

Vue.use(VModal, { dynamic: true, injectModalsContainer: true })
Vue.use(VueLodash, { lodash: lodash })
Vue.use(VTooltip)
Vue.use(VueLuxon, {
  templates: {
    clientAUS: {
      zone: 'local',
      format: 'ccc MMM d, y t'
    }
  },
  output: 'clientAUS'
})
Vue.use(VueApexCharts)
Vue.use(VueCal)
Vue.component('apexchart', VueApexCharts)
Vue.component('vue-cal', VueCal)
Vue.mixin({ methods: helpers })

Vue.filter('datetime', function (value) {
  if (!value) return ''
  const dt = new Date(value)
  const day = i18n.t('datetime.shortDay.' + dt.getDay())
  const date = dt.getDate()
  const dateSuffix = i18n.t('datetime.dateSuffix.' + dt.getDate())
  const month = i18n.t('datetime.shortMonth.' + dt.getMonth())
  const year = dt.getFullYear()
  let hour = dt.getHours()
  let meridiem = 'am'
  if (hour > 12) {
    hour -= 12
    meridiem = 'pm'
  }
  const minute = String(dt.getMinutes()).padStart(2, '0')
  return `${day} ${date}${dateSuffix} ${month} ${year}, ${hour}:${minute}${meridiem}`
})

Vue.filter('timediff', function (start, end) {
  if (!start || !end) return ''
  const st = new Date(start)
  const et = new Date(end)
  const diffMs = (et - st)
  const diffHrs = Math.floor((diffMs % 86400000) / 3600000)
  const diffMins = String(Math.round(((diffMs % 86400000) % 3600000) / 60000)).padStart(2, '0')
  return `${diffHrs}:${diffMins}`
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
